 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"branches~dashboard~edit sale~employee-details~employees~incomes~losses~new order~new sale~orders~pro~b16e6dd9":"branches~dashboard~edit sale~employee-details~employees~incomes~losses~new order~new sale~orders~pro~b16e6dd9","branches~dashboard~employee-details~employees~incomes~losses~orders~productDetails~products~sales~se~d85cfaea":"branches~dashboard~employee-details~employees~incomes~losses~orders~productDetails~products~sales~se~d85cfaea","branches":"branches","sharedSale":"sharedSale","dashboard":"dashboard","employee-details":"employee-details","employees":"employees","incomes":"incomes","losses":"losses","orders":"orders","sales":"sales","settings":"settings","products":"products","edit sale~new order~new sale~signUp":"edit sale~new order~new sale~signUp","edit sale":"edit sale","new sale":"new sale","signUp":"signUp","new order":"new order","signIn":"signIn","stocks":"stocks","productDetails":"productDetails","emailVerification":"emailVerification","pricing":"pricing"}[chunkId]||chunkId) + "." + {"branches~dashboard~edit sale~employee-details~employees~incomes~losses~new order~new sale~orders~pro~b16e6dd9":"769722a2","branches~dashboard~employee-details~employees~incomes~losses~orders~productDetails~products~sales~se~d85cfaea":"a7a9d271","branches":"c0d176d9","sharedSale":"4c9b09c6","chunk-e4bd64c6":"561527d9","chunk-c92a1d3e":"f7d29897","dashboard":"3ec659d2","employee-details":"9bb9c860","employees":"79c76ecc","incomes":"21bedbaf","losses":"814e7056","orders":"5c98fded","sales":"eb3ea0b3","settings":"b4f8df7e","products":"5f8f94e9","edit sale~new order~new sale~signUp":"2364a01b","edit sale":"beb7c9d3","new sale":"a88c84f9","signUp":"4eee04ea","new order":"7078f284","signIn":"748ad8ef","stocks":"6cb3e05b","productDetails":"6c3bf8a8","chunk-2d0be2ec":"9a7d20df","chunk-f7963dfa":"3cf98b84","emailVerification":"8d278e24","pricing":"1ba140d8","chunk-2d2223f3":"98f95a6c","chunk-2d229077":"b4e32f3a","chunk-487e3382":"746711b1","chunk-1537c1d8":"aedef744","chunk-2d0f0a1f":"b144daad","chunk-b93436a2":"ecba9f8b","chunk-3fd27a42":"acafff66","chunk-3eae6a05":"ca3626b5","chunk-7cb1d3c9":"7c615672","chunk-36e1e212":"2716358d","chunk-574041b4":"164841b1","chunk-607bce36":"dca4128b"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"branches~dashboard~edit sale~employee-details~employees~incomes~losses~new order~new sale~orders~pro~b16e6dd9":1,"branches":1,"sharedSale":1,"chunk-e4bd64c6":1,"chunk-c92a1d3e":1,"dashboard":1,"employee-details":1,"employees":1,"incomes":1,"losses":1,"orders":1,"sales":1,"settings":1,"products":1,"edit sale~new order~new sale~signUp":1,"edit sale":1,"new sale":1,"signUp":1,"new order":1,"signIn":1,"stocks":1,"productDetails":1,"chunk-f7963dfa":1,"pricing":1,"chunk-487e3382":1,"chunk-1537c1d8":1,"chunk-b93436a2":1,"chunk-3fd27a42":1,"chunk-3eae6a05":1,"chunk-7cb1d3c9":1,"chunk-36e1e212":1,"chunk-574041b4":1,"chunk-607bce36":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"branches~dashboard~edit sale~employee-details~employees~incomes~losses~new order~new sale~orders~pro~b16e6dd9":"branches~dashboard~edit sale~employee-details~employees~incomes~losses~new order~new sale~orders~pro~b16e6dd9","branches~dashboard~employee-details~employees~incomes~losses~orders~productDetails~products~sales~se~d85cfaea":"branches~dashboard~employee-details~employees~incomes~losses~orders~productDetails~products~sales~se~d85cfaea","branches":"branches","sharedSale":"sharedSale","dashboard":"dashboard","employee-details":"employee-details","employees":"employees","incomes":"incomes","losses":"losses","orders":"orders","sales":"sales","settings":"settings","products":"products","edit sale~new order~new sale~signUp":"edit sale~new order~new sale~signUp","edit sale":"edit sale","new sale":"new sale","signUp":"signUp","new order":"new order","signIn":"signIn","stocks":"stocks","productDetails":"productDetails","emailVerification":"emailVerification","pricing":"pricing"}[chunkId]||chunkId) + "." + {"branches~dashboard~edit sale~employee-details~employees~incomes~losses~new order~new sale~orders~pro~b16e6dd9":"c0da0764","branches~dashboard~employee-details~employees~incomes~losses~orders~productDetails~products~sales~se~d85cfaea":"31d6cfe0","branches":"4f0c4179","sharedSale":"557c16db","chunk-e4bd64c6":"d4cd5d80","chunk-c92a1d3e":"a335b1d9","dashboard":"44f4415e","employee-details":"85d602b2","employees":"7155c5ba","incomes":"48b227c8","losses":"bb377f75","orders":"9003c54e","sales":"11583aec","settings":"a1c56544","products":"f7eb1504","edit sale~new order~new sale~signUp":"7d3b9283","edit sale":"919630e1","new sale":"919630e1","signUp":"83c05168","new order":"b5b04f16","signIn":"f9895eb0","stocks":"4d48aa8a","productDetails":"50502628","chunk-2d0be2ec":"31d6cfe0","chunk-f7963dfa":"318c2767","emailVerification":"31d6cfe0","pricing":"e4a68992","chunk-2d2223f3":"31d6cfe0","chunk-2d229077":"31d6cfe0","chunk-487e3382":"34808d9c","chunk-1537c1d8":"f97bcc06","chunk-2d0f0a1f":"31d6cfe0","chunk-b93436a2":"7d3b9283","chunk-3fd27a42":"0824ad1f","chunk-3eae6a05":"a4f20f9e","chunk-7cb1d3c9":"532b3614","chunk-36e1e212":"df3947bd","chunk-574041b4":"d86198a4","chunk-607bce36":"ac348a9d"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
